<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/50TsKv/tc-custom/9780802189776.jpg?1707880535470" alt="This image is the cover for the book History of Wolves"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">History of Wolves
      </h1>
      <p class="bookDescription body article font2">
        <b>A teenage girl comes of age amid hidden dangers and family secrets in the Minnesota woods in this “beautiful, icy [and] electrifying debut” novel (NPR).</b><br/><br/>Teenage Linda lives with her parents in the austere woods of northern Minnesota, where their nearly abandoned commune stands as a last vestige of a counter-culture world. Isolated at home and an outsider at school, Linda is drawn to the new history teacher Mr. Grierson. But his shocking arrested for child pornography leaves Linda adrift as she wrestles with her own fledgling desires.<br/><br/>When the young Gardner family moves in across the lake, Linda finds herself welcomed into their home as a babysitter for their little boy. But this new sense of belonging comes with secrets and expectations she doesn’t understand. Over the course of a summer, Linda will have to make choices that reverberate throughout her life.<br/><br/><b>Finalist for the Man Booker Award</b><br/><br/><b>One of the <i>New York Times</i> 100 Notable Books of 2017</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Emily Fridlund
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8ca2fe9c